import React from "react";
import classnames from "classnames";
import { PlusIcon, VerticalDotsIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";

import { store as useStore } from "@components/VerticalLayout/store";
import {
    store,
    setIsPlusIconClicked,
    setIsActionsClicked,
    setActions,
    setIsEdited,
} from "./store";

import ErrorToast from "@components/Common/ErrorTost";
import { CustomMainColorButtonWithIcon } from "@components/Common/CustomMainColorButtonWithIcon";
import { CustomMainColorIconButton } from "@components/Common/CustomMainColorIconButton";

export function CustomSideFilter({
    selectedRows,
    setLocalFilterActive,
    isAddApplication,
    setIsAddApplication,
    isApplicationArchived,
    setIsApplicationArchived,
    setIsInInitializationModalOpened,
    setIsHistoryModalOpened,
    isHistoryModalOpened,
    setIsConfirmationModalArchived,
    setIsConfirmationModalActive,
    setSelectedRows,
    shopIds,
}: any) {
    const { t } = useTranslation();
    const { oneShop } = useSnapshot(useStore);
    const {
        numberArchived,
        numberActive,
        isEdited,
        modify,
        isActionsClicked,
    } = useSnapshot(store);

    const isExistDevice = React.useCallback(() => {
        let isExist: boolean = false;
        let existDevice: any[] = [];
        selectedRows !== undefined &&
            Object.values(selectedRows).length !== 0 &&
            Object.values(selectedRows).forEach((row: any) => {
                if (row[t("Shop")] === "") {
                    if (row.subRows !== undefined && row.subRows.length > 0) {
                        existDevice.push(row);
                    }
                }
            });
        if (existDevice.length > 0) {
            isExist = true;
        }
        return isExist;
    }, [selectedRows, t]);

    let IsExistPeripheral: boolean = isExistDevice();
    function isDisable() {
        let isExist: boolean = false;
        selectedRows !== undefined &&
            Object.values(selectedRows).length !== 0 &&
            Object.values(selectedRows).forEach((row: any) => {
                if (row[t("Application")] !== "") {
                    isExist = true;
                }
            });

        return isExist;
    }

    return (
        <div className="d-flex justify-content-start align-items-center ml-2">
            {modify === true && (
                <>
                    {isAddApplication !== true ? (
                        <span
                            onClick={() => {
                                setIsAddApplication(!isAddApplication);
                                oneShop && setSelectedRows([]);
                                setLocalFilterActive(false);
                            }}
                            className={
                                isApplicationArchived ||
                                (!oneShop && shopIds.length === 0)
                                    ? "w-100 ml-2 not-allowed-icon__clz cmn_btn_openForm"
                                    : "w-100 ml-2 cmn_btn_openForm"
                            }
                        >
                            <CustomMainColorButtonWithIcon
                                icon="PlusIcon"
                                iconPosition="left"
                                rounded
                                variant="primary"
                            >
                                {t("Add an application")}
                            </CustomMainColorButtonWithIcon>
                        </span>
                    ) : (
                        <CustomMainColorIconButton
                            icon="PlusIcon"
                            rounded
                            disabled={selectedRows.length === 0 ? true : false}
                            onClick={() => {
                                if (isEdited === true)
                                    setIsInInitializationModalOpened(true);
                                else {
                                    setIsPlusIconClicked(true);
                                }
                            }}
                        >
                            <PlusIcon height={20} width={20} fill="white" />
                        </CustomMainColorIconButton>
                    )}
                </>
            )}
            <VerticalDotsIcon
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                style={{ cursor: "pointer" }}
                height={25}
                width={25}
                fill="black"
                className="cmn_drp_FRmenu"
            />
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item pl-1 cmn_btn_FRlistActivated"
                    )}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                setIsEdited(false);
                                setIsApplicationArchived(false);
                            });
                        } else {
                            setIsApplicationArchived(false);
                        }
                    }}
                >
                    {t("Activated(s) application(s)")} ({numberActive})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item pl-1 cmn_btn_FRlistArchived"
                    )}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                setIsEdited(false);
                                setIsApplicationArchived(true);
                            });
                        } else {
                            setIsApplicationArchived(true);
                        }
                    }}
                >
                    {t("Archived(s) application(s)")} ({numberArchived})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={`${classnames(
                        "dropdown-item pl-1 cmn_btn_FRhistory",
                        {
                            "not-allowed-icon__clz":
                                selectedRows.length === 0 || !isDisable(),
                        }
                    )}`}
                    onClick={() => {
                        if (isEdited === true) {
                            setIsActionsClicked(!isActionsClicked);
                            setActions(() => {
                                setIsEdited(false);
                                setIsHistoryModalOpened(!isHistoryModalOpened);
                            });
                        } else {
                            setIsHistoryModalOpened(!isHistoryModalOpened);
                        }
                    }}
                >
                    {t("Historical")}
                </div>
                {modify === true && (
                    <>
                        <div
                            style={{ cursor: "pointer" }}
                            className={`${classnames(
                                "dropdown-item pl-1",
                                {
                                    "not-allowed-icon__clz":
                                        selectedRows.length === 0 ||
                                        !isDisable(),
                                },

                                isApplicationArchived
                                    ? "cmn_btn_FRunarchive"
                                    : "cmn_btn_FRarchived"
                            )}`}
                            onClick={() => {
                                if (isApplicationArchived) {
                                    setIsConfirmationModalActive(true);
                                } else {
                                    if (IsExistPeripheral) {
                                        ErrorToast(
                                            t(
                                                "Please note that you cannot archive a application associated with an device."
                                            )
                                        );
                                    } else {
                                        setIsConfirmationModalArchived(true);
                                    }
                                }
                            }}
                        >
                            {isApplicationArchived
                                ? `${t("Dearchive")}`
                                : `${t("Archive")}`}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
